import React from 'react';

import './DocsToDownloadPageBanner.scss'

const DocsToDownloadPageBanner = () => {

   return (
      <header className="docs-to-download-page-heading-image">
         <hr className='separator docs-to-download-page-heading-separator'/>
         <hr className='separator docs-to-download-page-heading-separator'/>
         <div className='docs-to-download-page-title'>
            <h1>Pliki do pobrania</h1>
         </div>
      </header>
   )
}

export default DocsToDownloadPageBanner